export const CoursesHeader1 = `<div class=" common-details">
<div class="common-name"></div>
</div>`;
